export default __webpack_public_path__ + "static/media/success.069c5aa6.svg";